'use strict';
import * as _ from 'lodash';
import moment from 'moment';
import {module} from '../app';
import {displayNone} from "../constants/displayStyleConstants";
import * as constantStrings from "../constants/constantStrings";

module
  .factory('FollowUpDetailDialogModel', [

    '$q', 'Patient', 'modalService', 'FollowUpsDomain', 'Worklist', 'ReferencePhysician',
    '$ionicLoading', 'tpConfig', 'signalrService', 'ionicDatePicker', 'datePickerService',

    function ($q, Patient, modalService, FollowUpsDomain, Worklist, ReferencePhysician,
              $ionicLoading, tpConfig, signalrService, ionicDatePicker, datePickerService) {

      function FollowUpDetailDialogModel(patientSsn, defaultRefPhy, followUpId, canEdit = true, checkIfStillOwningAndNotOffline) {

        let self = this;

        self.getAllRefPhyPromise = null;
        self.checkIfStillOwningAndNotOffline = checkIfStillOwningAndNotOffline;
        self.requiredFields = ['Location', 'StudyDate', 'RecallDate', 'Assessment', 'Recommendation', 'Side', 'RefNum'];

        const refPhyFieldTitle = 'Referring Physician';
        const refPhyFieldName = 'RefNum';
        let networkUnavailableMessage = 'Network unavailable. Please check your network settings.';
        let clientSideDateFormat = 'MM/DD/YYYY';
        self.canEdit = canEdit;
        self.followUpId = followUpId;
        self.recommendations = [];
        self.assessments = [];
        self.refPhys = [defaultRefPhy];
        self.queueRequests = [];
        self.modalityOptions = [
          {
            Code: 'M',
            Description: 'Mammogram'
          },
          {
            Code: 'U',
            Description: 'Ultrasound'
          },
          {
            Code: 'R',
            Description: 'MRI'
          },
          {
            Code: 'B',
            Description: 'Biopsy'
          }
        ];
        self.sideOptions = [
          {
            Code: 'L',
            Description: 'Left'
          },
          {
            Code: 'R',
            Description: 'Right'
          },
          {
            Code: 'B',
            Description: 'Bilateral'
          }
        ];
        self.isLoadingMore = false;
        self.pageIndex = 0;
        self.stopInfiniteLoad = true;
        self.query = undefined;
        self.loadedRefPhies = [];
        self.templateData = {
          showLoadMore: true
        };

        self.modalInstance = null;

        if (defaultRefPhy && defaultRefPhy.RefNum) {
          self.refPhyPlaceholder = composeRefPhyDisplayName(defaultRefPhy);
        }

        self.data = {
          Location: '',
          Ssn: patientSsn,
          StudyDate: null,
          RecallDate: null,
          Assessment: '',
          Recommendation: '',
          Modality: '',
          Side: '',
          RefNum: defaultRefPhy && defaultRefPhy.RefNum
        };
        self.canceledLoadRefPhys = false;
        self.isInitialized = false;
        self.originalData = _.cloneDeep(self.data);

        self.getRecommendations = function () {
          if (!self.data.Assessment) {
            return [];
          }

          let recommendations = _.filter(self.recommendations, function (recommendation) {
            return _.includes(recommendation.SpecialCondition, self.data.Assessment.trim());
          });

          return recommendations;
        };

        self.getRefPhyAutocomplete = function (query) {

          if (self.query === query) {
            self.pageIndex++;
            self.isLoadingMore = true;
          } else {
            self.isLoadingMore = false;
          }

          if (!self.query) {
            self.query = '';
          }

          self.query = query;

          if (self.getAllRefPhyPromise && self.getAllRefPhyPromise.canceler) {
            self.canceledLoadRefPhys = true;
            self.getAllRefPhyPromise.canceler.resolve();
          }

          var usedRefPhyKeys = [];
          if (self.data.RefNum) {
            usedRefPhyKeys.push(Array.isArray(self.data.RefNum) ? self.data.RefNum[0] : self.data.RefNum);
          }

          self.getAllRefPhyPromise = ReferencePhysician.loadForAutocomplete(query, self.pageIndex || 0, usedRefPhyKeys, self.isInitialized);

          return self.getAllRefPhyPromise
            .then(function (response) {
              self.canceledLoadRefPhys = false;
              self.stopInfiniteLoad = response.data.length === 0;
              self.templateData.showLoadMore = !self.stopInfiniteLoad;

              const newMapArray = response.data.map(function (record) {
                record.DisplayName = composeRefPhyDisplayName(record);
                return record;
              });
              if (self.isLoadingMore) {
                self.loadedRefPhies = self.loadedRefPhies.concat(newMapArray);
              } else {
                self.loadedRefPhies = newMapArray;
              }

              return {
                List: self.loadedRefPhies,
                IsError: false,
                ErrorMessage: ''
              }
            }, function (error) {
              if (self.canceledLoadRefPhys) {
                return;
              }
              self.stopInfiniteLoad = true;

              let message = error.statusText;
              if (error.status == -1) {
                message = networkUnavailableMessage;
              }

              return { List: [], IsError: true, ErrorMessage: message };
            }
            );
        };

        self.getRefPhyByKey = async function (selectedKey) {

          if (!selectedKey || !selectedKey.length) {
            return;
          }

          let filteredRefPhys = self.getRefPhyFromCache(selectedKey);
          if (filteredRefPhys && filteredRefPhys.length) {
            return filteredRefPhys;
          }

          filteredRefPhys = self.getRefPhyFromRecentAutocomplete(selectedKey);
          if (filteredRefPhys && filteredRefPhys.length) {
            return filteredRefPhys;
          }

          let refPhy = await ReferencePhysician.get(Array.isArray(selectedKey) ? selectedKey[0] : selectedKey);
          if (refPhy && !self.refPhys.some(ref => ref.RefNum.trim() === refPhy.RefNum.trim())) {
            refPhy.DisplayName = composeRefPhyDisplayName(refPhy);
            self.refPhys.push(refPhy);
          }
          return [refPhy];
        };

        self.getRefPhyFromCache = function (selectedKey) {
          return self.getRefPhyFromArray(selectedKey, self.refPhys);
        }

        self.getRefPhyFromRecentAutocomplete = function (selectedKey) {
          let items = self.getRefPhyFromArray(selectedKey, self.loadedRefPhies);
          items.forEach(item => {
            if (item && !self.refPhys.some(ref => ref.RefNum.trim() === item.RefNum.trim())) {
              self.refPhys.push(item);
            }
          });
          return items;
        };

        self.getRefPhyFromArray = function (selectedKey, array) {
          if (!array || array.length == 0) {
            return [];
          }
          return array.filter(function (element) {
            if (Array.isArray(selectedKey)) {
              return element.RefNum === selectedKey[0];
            } else {
              return (element.RefNum && element.RefNum.trim()) === (selectedKey && selectedKey.trim());
            }
          });
        };

        self.refPhySelected = function (callback) {
          self.resetAutocomplete();
        };

        self.resetAutocomplete = function () {
          self.query = undefined;
          self.pageIndex = 0;
          self.isLoadingMore = false;
          self.onRefPhyAutocompleteModalClosed();
        };

        self.save = async function () {
          let missingFields = [];

          _.each(self.requiredFields, function (field) {
            if (!self.data[field] || (self.data[field] && self.data[field].length == 0)) {
              if(field === refPhyFieldName){
                missingFields.push(refPhyFieldTitle);
              }else{
                missingFields.push(field.split(/(?=[A-Z])/).join(' '));
              }
            }
          });

          if (missingFields.length) {
            let msg = 'The following fields are required: ' + missingFields.join(', ') + '. Please correct your data.';
            modalService.showAlert(msg);
            return;
          }

          if (self.data.StudyDate > new Date()) {
            let msg = 'Study date must be in the past.';
            modalService.showAlert(msg);
            return;
          }

          //Check if still owning
          $ionicLoading.show({template: constantStrings.processingLoaderMessage});
          const isOwnershipLost = !await self.checkIfStillOwningAndNotOffline();
          if(isOwnershipLost){
            $ionicLoading.hide();
            self.modalInstance.remove();
            return;
          }

          self.executeSaveData();
        };

        self._getClonedData = function () {
          let clonedData = _.cloneDeep(self.data);
          clonedData.StudyDate = moment(clonedData.StudyDate).format(clientSideDateFormat);
          clonedData.RecallDate = moment(clonedData.RecallDate).format(clientSideDateFormat);
          clonedData.RefNum = angular.isArray(clonedData.RefNum) ? clonedData.RefNum[0] : clonedData.RefNum;
          return clonedData;
        }

        self.executeSaveData = function () {

          let clonedData = self._getClonedData();

          let promiseOperation = !self.followUpId ? FollowUpsDomain.createFollowUps(clonedData) : FollowUpsDomain.updateFollowUps(self.followUpId, clonedData);

          $ionicLoading.show({
            template: 'Saving follow-up. Please wait...'
          });
          promiseOperation
            .then(function (response) {
              $ionicLoading.hide();
              modalService.showAlert('Follow-up saved successfully.', function () {
                self.modalInstance.remove();
              });
            }, function (error) {
              $ionicLoading.hide();
              if (error.status == -1) {// network error
                self.needRetrySave = true;
                $ionicLoading.show({
                  template: 'Network problem. Retrying...'
                });
              }
              console.log(error);
            });
        };

        self._hasChanged = function () {
          let clonedData = _.cloneDeep(self.data);
          if (Array.isArray(clonedData.RefNum)) {
            clonedData.RefNum = clonedData.RefNum[0];
          }
          ;
          return !_.isEqual(clonedData, self.originalData);
        }

        self.init = function (modal, scope) {
          self.modalInstance = modal;
          self._scope = scope;

          self._scope.$on(tpConfig.events.portalNetworkAvailabilityChanged, self.onNetworkAvailabilityChanged);

          self.initializeData();
        };

        self.onNetworkAvailabilityChanged = function (scope, data) {
          if (data.isOnline) {
            if (self.needRefresh) {
              self.needRefresh = false;
              self.initializeData();
            }
            if (self.needRetrySave) {
              self.needRetrySave = false;
              self.executeSaveData();
            }
          }
        };

        self._getLocations = function () {
          return Worklist.getLocations()
            .then(function (resp) {
              self.locations = resp.data;
              return resp;
            }, function (error) {
              if (error.status == -1) {// network error
                self.needRefresh = true;
              }
            });
        };

        self._getRecommendations = function () {
          return FollowUpsDomain.getRecommendations()
            .then(function (response) {
              self.recommendations = response;
            }, function (error) {
              if (error.status == -1) {// network error
                self.needRefresh = true;
              }
            });
        };

        self._getAssessments = function () {
          return FollowUpsDomain.getAssessments()
            .then(function (response) {
              self.assessments = _.orderBy(response, function (e) { return e.Description }, ['asc']);
            }, function (error) {
              if (error.status == -1) {// network error
                self.needRefresh = true;
              }
            });
        };

        self._getFollowUpDetail = function (followUpId) {
          return FollowUpsDomain.getFollowUp(followUpId)
            .then(function (response) {
              response.StudyDate = new Date(moment(response.StudyDate).format(clientSideDateFormat));
              response.RecallDate = new Date(moment(response.RecallDate).format(clientSideDateFormat));
              self.data = response;
              self.originalData = _.cloneDeep(self.data);
              return response;
            }, function (error) {
              if (error.status == -1) {// network error
                self.needRefresh = true;
              }
            });
        };

        self.initializeData = function () {
          if (!signalrService.isConnected) {
            self.needRefresh = true;

            modalService.showAlert(networkUnavailableMessage);
            return;
          }

          let promise = [
            self._getLocations(),

            self._getRecommendations(),

            self._getAssessments()
          ];

          if (self.followUpId) {
            promise.push(self._getFollowUpDetail(self.followUpId));
          }

          $ionicLoading.show('Loading...');
          return $q.all(promise)
            .finally(function () {
              $ionicLoading.hide();
              if (self.needRefresh) {
                modalService.showAlert(networkUnavailableMessage);
              }
            });
        };

        self.closeWindow = function () {
          if (self._hasChanged()) {
            modalService.showConfirmation(null, 'You have unsaved changes. Are you sure you want to cancel?')
              .then(function (confirmed) {
                if (confirmed) {
                  self.close();
                }
              });
            return;
          }
          self.close();
        };

        self.close = function () {
          self.modalInstance.remove();
        };

        self.changeDate = function (field) {
          let val = self.data[field];

          let minDate;
          let maxDate;

          if (field === 'RecallDate') {
            let today = new Date();
            minDate = today.setDate(today.getDate() + 1);
            maxDate = null;
          } else if (field === 'StudyDate') {
            minDate = new Date(1900, 1, 1);
            maxDate = new Date();
          }
          const changeDateModel = {
            obj: self.data,
            id: field,
            minDate: minDate,
            maxDate: maxDate
          };
          datePickerService.changeDate(changeDateModel);
        };

        self.onRefPhyAutocompleteModalClosed = ($event) => {
          // Fixed issue when Modality/Side dropdowns are being opened on selecting ref phy in followUpEditRefPhyDialog
          // Android: preventing followUpDetail modal clicks when followUpEditRefPhyDialog is opened
          // timeout needed to make sure that modal & keyboard is closed on android tablet
          setTimeout(() => {
            self.refPhyPlaceholder = '';
            self.canEdit = true;
          }, 50);
        };

        self.onRefPhyAutocompleteInputClick = ($event) => {
          // Fixed issue when Modality/Side dropdowns are being opened on selecting ref phy in followUpEditRefPhyDialog
          // Android: preventing followUpDetail modal clicks when followUpEditRefPhyDialog is opened
          self.canEdit = false;
        };

        document.onRefPhyAutocompleteTouchEnd = (event) => {
          // Fixed issue when Modality/Side dropdowns are being opened on selecting ref phy in followUpEditRefPhyDialog
          // touchend event can have different position than touchstart event. In this case followUpEditRefPhyDialog
          // will not be opened. This code is making sure that it was opened on touchend event
          setTimeout(() => {
            const followUpEditRefPhyDialogElement = document.getElementById('follow-up-edit-ref-phy-dialog');
            const shouldDisableEditing = followUpEditRefPhyDialogElement && followUpEditRefPhyDialogElement.style.display !== displayNone;
            if (shouldDisableEditing) {
              self.canEdit = false;
            }
          }, 0);
        };
      }

      function composeRefPhyDisplayName(item) {
        return `${item.LastName && item.LastName.trim()} ${item.FirstName && item.FirstName.trim()} (${item.RefNum.trim()})`;
      }

      return FollowUpDetailDialogModel;
    }
  ]);



// WEBPACK FOOTER //
// ./src/scripts/models/followUpDetail.js